import { render, staticRenderFns } from "./FavoriteIllusts.vue?vue&type=template&id=f54b9a98&scoped=true"
import script from "./FavoriteIllusts.vue?vue&type=script&lang=js"
export * from "./FavoriteIllusts.vue?vue&type=script&lang=js"
import style0 from "./FavoriteIllusts.vue?vue&type=style&index=0&id=f54b9a98&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54b9a98",
  null
  
)

export default component.exports